<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-network-status-banner></app-network-status-banner>
</ion-app>
